import { Injectable } from '@angular/core';
import { ProductNavbar } from './product-navbar';
import {MenuItem} from 'primeng/api';
import { OidcAuthService } from '@auth/services/oidc-auth.service';
import { filter, map, distinctUntilChanged } from 'rxjs';
import { empty, of, BehaviorSubject, Observable } from 'rxjs';
import { RoleService } from '@roles/services/role.service';
import { MojoWellKnownNames } from '@common/constants/mojo-well-known-names';
import { WellKnownRoutePaths } from '@routing/well-known-route-paths';
import { UserSettingsService } from '@feature/user-settings';

@Injectable({
  providedIn: 'root'
})
export class MciNavbarService implements ProductNavbar {

  private _systemMenuItems = new BehaviorSubject<MenuItem[]>([]);
  get systemMenuItems() {
    return this._systemMenuItems.asObservable();
  }
  requestPreviewMode: Observable<string> = empty();
  userMenuItems: Observable<MenuItem[]> = of([]);
  userName: Observable<string>;

  _homepageUrl = '/main';

  get homepageUrl(): Observable<string> {
    return of(this._homepageUrl);
  }

  constructor(
    private readonly roleService: RoleService,
    private readonly authService: OidcAuthService,
    private readonly userSettingsService: UserSettingsService) {
  }

  initialise(): void {
    const userProfileChanged = this.authService.getUserProfile().pipe(distinctUntilChanged(), filter((profile) => profile != null));
    this.userName = userProfileChanged.pipe(map(profile => profile.userName));
    const items: MenuItem[] = [];
    items.push({ label: 'Home', routerLink: this._homepageUrl });

    if (this.userSettingsService.getUserSettingsImmediate().FaqEnabled) {
      items.push({ label: 'FAQ', url: '/faq', target: '_blank' });
    }

    if (this.roleService.isInRole(MojoWellKnownNames.RoleNames.ClientAdministrator)) {
      items.push({ label: 'Admin Dashboard', routerLink: WellKnownRoutePaths.fromRoot(WellKnownRoutePaths.CurrentProduct.adminDashboard) });
    }

    this._systemMenuItems.next(items);
  }


}
